var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { CurrentSheetAtom, PagesAtom } from "@/atoms";
import { CONFIG } from "@/config";
import { getPageIndex, SheetSide } from "@/utils/pages";
import { useMediaQueries } from "@/utils/useMediaQuery";
import { useAtomValue } from "jotai";
import React, { useEffect, useMemo, useRef, useState } from "react";
import Slicker from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import styles from "./PagesPreview.module.scss";
import { PageThumbnail } from "./PageThumbnail";
import { SliderArrow } from "./SliderArrow";
var PAGES_GROUPS_BY_SIZE = [
    { mediaQuery: "(max-width: 1080px)", size: 3 },
    { mediaQuery: "(min-width: 1080px) and (max-width: 1400px)", size: 6 },
    { mediaQuery: "(min-width: 1400px)", size: 9 },
];
export var PagesPreview = function (_a) {
    var onSelectSheet = _a.onSelectSheet;
    var currentSheet = useAtomValue(CurrentSheetAtom);
    var pages = useAtomValue(PagesAtom);
    var slicker = useRef(null);
    var _b = __read(useState(0), 2), slideIndex = _b[0], setSlideIndex = _b[1];
    var slideSize = useMediaQueries(PAGES_GROUPS_BY_SIZE.map(function (_a) {
        var mediaQuery = _a.mediaQuery, size = _a.size;
        return [mediaQuery, size];
    }), 9);
    var sheetsGroups = useMemo(function () {
        return __spreadArray([], __read(Array(pages.getSheetCount())), false).map(function (_, i) { return [
            pages.getThumbnail(getPageIndex(i, SheetSide.back)),
            pages.getThumbnail(getPageIndex(i + 1, SheetSide.front)),
        ]; });
    }, [pages]);
    var slides = useMemo(function () {
        return sheetsGroups.reduce(function (slides, page, index) {
            var slideNumber = Math.floor(index / slideSize);
            while (slides.length <= slideNumber) {
                slides.push([]);
            }
            slides[slideNumber].push(page);
            return slides;
        }, []);
    }, [sheetsGroups, slideSize]);
    useEffect(function () {
        var minSheet = slideSize * slideIndex;
        var maxSheet = minSheet + slideSize - 1;
        if (currentSheet < minSheet || currentSheet > maxSheet) {
            setSlideIndex(Math.floor(currentSheet / slideSize));
        }
    }, [currentSheet, slideIndex, slideSize, setSlideIndex]);
    useEffect(function () {
        var _a;
        (_a = slicker.current) === null || _a === void 0 ? void 0 : _a.slickGoTo(slideIndex, true);
    }, [slideIndex]);
    // Duplicate slide state extracted from the Slicker component for reuse here
    var _c = __read(useState(0), 2), currentSlide = _c[0], setCurrentSlide = _c[1];
    var getRangeForSlide = function (slide) {
        var slideCount = Math.ceil(pages.getPageCount() / 2 / slideSize);
        if (slide < 0 || slide >= slideCount) {
            return null;
        }
        return [
            slide * slideSize * 2 + 1,
            Math.min(pages.getPageCount(), (slide + 1) * slideSize * 2),
        ];
    };
    return (React.createElement("div", { className: styles.pagesPreview },
        React.createElement(Slicker, { ref: slicker, dots: false, centerMode: true, focusOnSelect: true, swipeToSlide: false, draggable: false, infinite: false, centerPadding: "0px", slidesToShow: 1, arrows: true, prevArrow: React.createElement(SliderArrow, { direction: "prev", range: getRangeForSlide(currentSlide - 1) }), nextArrow: React.createElement(SliderArrow, { direction: "next", range: getRangeForSlide(currentSlide + 1) }), beforeChange: function (prev, next) {
                if (next !== currentSlide) {
                    setCurrentSlide(next);
                }
            }, lazyLoad: "progressive", accessibility: false }, slides.map(function (pages, slideIndex) { return (React.createElement("div", { key: "slide_".concat(slideIndex, "_").concat(pages.length) },
            React.createElement("div", { className: styles.slide }, pages.map(function (_a, pageIndex) {
                var _b = __read(_a, 2), left = _b[0], right = _b[1];
                return (React.createElement(PageThumbnail, { key: "".concat(left, "_").concat(right), leftImg: left, rightImg: right, numberLeft: slideIndex * slideSize * 2 +
                        pageIndex * 2 +
                        CONFIG.pages.firstPageNumber, active: currentSheet == slideIndex * slideSize + pageIndex, onClick: function () {
                        return onSelectSheet(slideIndex * slideSize + pageIndex);
                    } }));
            })))); }))));
};
